import Vue from 'vue'
import Router from 'vue-router'
import temp from '@/views/temp/index'
import index from '@/views/index/index'

Vue.use(Router);

export default new Router({
  // mode:'history',
  routes: [
    //页面通用模板
    {
      path: '/',
      name: 'Temp',
      component: temp,
      redirect: "/index",
      children: [
        //首页
        {
          path: "/index",
          name: "Index",
          component: index,
          meta: {
            pass: "/index",
            tag: "/index"
          }
        },
        //投稿
        {
          path: "/manuscript",
          name: 'Manuscript',
          meta: {
            tag: "/manuscript"
          },
          component: () => import('@/views/manuscript/index')
        },
        //展演主题列表页
        {
          path:"/themeList",
          name:"/ThemeList",
          component:()=>import('@/views/active/themeList'),
          meta:{
            tag:"/themeList"
          }
        },
        //展演首页
        {
          path:"/active",
          name:"Active",
          component:()=>import('@/views/active/index'),
          meta:{
            tag:"/themeList"
          }
        },
        //展演列表页
        {
          path:"/activeList",
          name:"ActiveList",
          component:()=>import('@/views/active/list'),
          meta:{
            tag:"/themeList"
          }
        },
        //展演详情页
        {
          path:"/activeDetail",
          name:"ActiveDetail",
          component:()=>import('@/views/active/detail'),
          meta:{
            tag:"/themeList"
          }
        },
        //用户信息页
        {
          path: "/userInfo",
          name: "UserInfo",
          component: () => import('@/views/userinfo/index')
        },
        //创建新稿件
        {
          path: "/creat",
          name: "Creat",
          meta: {
            tag: "/manuscript"
          },
          component: () => import('@/views/manuscript/creat')
        },
        //稿件详情页
        {
          path: "/manuDetail",
          name: "manuDetail",
          meta: {
            tag: "/manuscript"
          },
          component: () => import('@/views/manuscript/detail')
        },
        //新闻列表页
        {
          path: "/news",
          name: "News",
          meta: {
            pass: "/index",
          },
          component: () => import('@/views/news/index')
        },
        //新闻详情页
        {
          path: "/newsDetail",
          name: "NewsDetail",
          meta: {
            pass: "/index",
          },
          component: () => import('@/views/news/detail')
        },
        //投稿记录
        {
          path: "/note",
          name: "Note",
          component: () => import('@/views/userinfo/note')
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js